<!--设置页面-->
<template>
    <v-main>
        <top-bar :height="'48vh'" title="设置" :isShowRefresh="false" icon="el-icon-setting" />
        <v-container fluid>
            <el-tabs tab-position="top" style="height: 100%" v-model="activeName">
                <el-tab-pane name="first">
                    <span
                        slot="label"
                        :style="{
                            color: activeName == 'first' ? '#4dabf7' : theme.pageFontColor,
                            fontSize: '1.1em',
                        }"
                    >
                        <i class="el-icon-key"></i>
                        修改密码
                    </span>
                    <div
                        :style="{
                            backgroundColor: theme.pageBgColor,
                            width: '100%',
                            height: '100%',
                        }"
                        class="mb-n6 pt-4 pb-7"
                    >
                        <el-form
                            :model="ruleForm"
                            ref="ruleForm"
                            status-icon
                            :rules="rules"
                            label-width="84px"
                            class="ml-5"
                        >
                            <el-form-item label="旧密码：" prop="oldPassword">
                                <el-input
                                    type="password"
                                    v-model="ruleForm.oldPassword"
                                    style="width: 20vw"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="新密码：" prop="newPassword">
                                <el-input
                                    type="password"
                                    v-model="ruleForm.newPassword"
                                    style="width: 20vw"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="再次输入：" prop="regPassword">
                                <el-input
                                    type="password"
                                    v-model="ruleForm.regPassword"
                                    style="width: 20vw"
                                ></el-input>
                            </el-form-item>
                            <el-button
                                type="danger"
                                @click="modify('ruleForm')"
                                style="width:10em"
                                class="mt-10 ml-15"
                            >
                                修改密码
                            </el-button>
                        </el-form>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="second">
                    <span
                        slot="label"
                        :style="{
                            fontSize: '1.1em',
                            color: activeName == 'second' ? '#4dabf7' : theme.pageFontColor,
                        }"
                    >
                        <i class="el-icon-magic-stick"></i>
                        主题切换
                    </span>
                    <div
                        :style="{
                            backgroundColor: theme.pageBgColor,
                            width: '100%',
                            height: '100%',
                        }"
                        class="mb-n6 pt-4 pb-7"
                    >
                        <v-row>
                            <v-col
                                cols="1"
                                md="1"
                                v-for="(item, index) in themes"
                                :key="index"
                                class="ml-10 mr-10"
                            >
                                <div
                                    :style="{
                                        width: '9em',
                                        height: '4.5em',
                                        backgroundImage: item.topBarBgColor,
                                        backgroundColor: item.topBarBgColor,
                                        border: '1px solid #d9d9d9',
                                    }"
                                    @click="switchTheme(item)"
                                ></div>
                            </v-col>
                        </v-row>
                        <el-button type="primary" plain @click="reset()" class="ml-9 mt-10">
                            重置
                        </el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="third">
                    <span
                        slot="label"
                        :style="{
                            fontSize: '1.1em',
                            color: activeName == 'fourth' ? '#4dabf7' : theme.pageFontColor,
                        }"
                    >
                        <i class="el-icon-attract" @click="dialog = true"></i>
                        数据接口
                    </span>
                    <div
                        :style="{
                            backgroundColor: theme.pageBgColor,
                            width: '100%',
                            height: '150vh',
                            overflowY: 'auto',
                        }"
                        class="mb-n6 pt-4 pb-7"
                    >
                        <iframe
                            scrolling="no"
                            src="http://ecar.meisenpay.com:8899/ecar/swagger-ui.html#/"
                            frameborder="0"
                            style="width:100%;height:500vh"
                        ></iframe>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="fourth">
                    <span
                        slot="label"
                        :style="{
                            fontSize: '1.1em',
                            color: activeName == 'fifth' ? '#4dabf7' : theme.pageFontColor,
                        }"
                    >
                        <i class="el-icon-switch-button"></i>
                        退出登录
                    </span>
                    <div
                        :style="{
                            backgroundColor: theme.pageBgColor,
                            width: '100%',
                            height: '100%',
                        }"
                        class="mb-n6 pt-4 pb-7"
                    >
                        <el-button
                            type="primary"
                            plain
                            class="ml-10"
                            icon="el-icon-switch-button"
                            @click="logOut()"
                        >
                            退出登录
                        </el-button>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </v-container>
    </v-main>
</template>
<script>
import util from "@/util";
import TopBar from "@/components/TopBar";
import store from "@/store";
import { mapState } from "vuex";
export default {
    name: "Set",
    data() {
        const validateOld = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入旧密码"));
            }
            callback();
        };
        const validateNew = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入新密码"));
            } else if (value === this.ruleForm.oldPassword) {
                callback(new Error("新密码与旧密码相同"));
            } else {
                if (this.ruleForm.regPassword !== "") {
                    this.$refs.ruleForm.validateField("regPassword");
                }
                callback();
            }
        };
        const validateReg = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入新密码"));
            } else if (value !== this.ruleForm.newPassword) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            dialog: false,
            activeName: "first",
            ruleForm: {
                oldPassword: "",
                newPassword: "",
                regPassword: "",
            },
            rules: {
                oldPassword: [{ validator: validateOld, trigger: "input" }],
                newPassword: [{ validator: validateNew, trigger: "input" }],
                regPassword: [{ validator: validateReg, trigger: "input" }],
            },
            themes: [
                {
                    topBarBgColor: "linear-gradient(to top, #9890e3 0%, #b1f4cf 100%)",
                    projectNameColor: "#4dabf7",
                    userNameColor: "#343a40",
                    titleBgColor: "#4dabf7",
                    titleFontColor: "black",
                    navigationDrawerBgColor: "#b1f4cf",
                    navigationDrawerFontColor: "#595959",
                    activeDrawerFontColor: "#08979c",
                    pageBgColor: "#f5f5f5",
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                },
                {
                    topBarBgColor: "linear-gradient(180deg, #2af598 0%, #009efd 100%)",
                    projectNameColor: "white",
                    userNameColor: "white",
                    titleBgColor: "white",
                    titleFontColor: "black",
                    navigationDrawerBgColor: "#009efd",
                    navigationDrawerFontColor: "#fff",
                    activeDrawerFontColor: "#002766",
                    pageBgColor: "#f5f5f5",
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                },
                {
                    topBarBgColor:
                        "linear-gradient(to right, #e4afcb 0%, #b8cbb8 0%, #b8cbb8 0%, #e2c58b 30%, #c2ce9c 64%, #7edbdc 100%)",
                    projectNameColor: "white",
                    userNameColor: "white",
                    titleBgColor: "white",
                    titleFontColor: "black",
                    navigationDrawerBgColor: "#7edbdc",
                    navigationDrawerFontColor: "#fff",
                    activeDrawerFontColor: "#006d75",
                    pageBgColor: "#f5f5f5",
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                },
                {
                    topBarBgColor: "linear-gradient(to top, #37ecba 0%, #72afd3 100%)",
                    projectNameColor: "white",
                    userNameColor: "white",
                    titleBgColor: "white",
                    titleFontColor: "black",
                    navigationDrawerBgColor: "#72afd3",
                    navigationDrawerFontColor: "#fff",
                    activeDrawerFontColor: "#002766",
                    pageBgColor: "#f5f5f5",
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                },
                {
                    topBarBgColor:
                        "linear-gradient(to right, #eea2a2 0%, #bbc1bf 19%, #57c6e1 42%, #b49fda 79%, #7ac5d8 100%)",
                    projectNameColor: "white",
                    userNameColor: "white",
                    titleBgColor: "white",
                    titleFontColor: "black",
                    navigationDrawerBgColor: "#57c6e1",
                    navigationDrawerFontColor: "#fff",
                    activeDrawerFontColor: "#006d75",
                    pageBgColor: "#f5f5f5",
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                },
                {
                    topBarBgColor: "linear-gradient(to top, #fff 0%, #fff 100%)",
                    projectNameColor: "#4dabf7",
                    userNameColor: "#343a40",
                    titleBgColor: "#4dabf7",
                    titleFontColor: "white",
                    navigationDrawerBgColor: "#fff",
                    navigationDrawerFontColor: "#545c64",
                    activeDrawerFontColor: "#4dabf7",
                    pageBgColor: "#e9ecef",
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                },
                {
                    topBarBgColor: "linear-gradient(to top, #c1dfc4 0%, #deecdd 100%)",
                    projectNameColor: "#4dabf7",
                    userNameColor: "#343a40",
                    titleBgColor: "#4dabf7",
                    titleFontColor: "white",
                    navigationDrawerBgColor: "#deecdd",
                    navigationDrawerFontColor: "black",
                    activeDrawerFontColor: "#4dabf7",
                    pageBgColor: "#f5f5f5",
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                },
                {
                    topBarBgColor: "linear-gradient(to top, #0ba360 0%, #3cba92 100%)",
                    projectNameColor: "white",
                    userNameColor: "white",
                    titleBgColor: "white",
                    titleFontColor: "black",
                    navigationDrawerBgColor: "#3cba92",
                    navigationDrawerFontColor: "#fff",
                    activeDrawerFontColor: "#262626",
                    pageBgColor: "#f5f5f5",
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                },
                {
                    topBarBgColor: "linear-gradient(to right, #74ebd5 0%, #9face6 100%)",
                    projectNameColor: "white",
                    userNameColor: "white",
                    titleBgColor: "white",
                    titleFontColor: "black",
                    navigationDrawerBgColor: "#9face6",
                    navigationDrawerFontColor: "#fff",
                    activeDrawerFontColor: "#722ed1",
                    pageBgColor: "#f5f5f5",
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                },
                {
                    topBarBgColor: "linear-gradient(to top, #9795f0 0%, #fbc8d4 100%)",
                    projectNameColor: "white",
                    userNameColor: "white",
                    titleBgColor: "white",
                    titleFontColor: "black",
                    navigationDrawerBgColor: "#fbc8d4",
                    navigationDrawerFontColor: "black",
                    activeDrawerFontColor: "#4dabf7",
                    pageBgColor: "#f5f5f5",
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                },
                {
                    topBarBgColor: "linear-gradient(to top, #a7a6cb 0%, #8989ba 52%, #8989ba 100%)",
                    projectNameColor: "white",
                    userNameColor: "white",
                    titleBgColor: "white",
                    titleFontColor: "black",
                    navigationDrawerBgColor: "#8989ba",
                    navigationDrawerFontColor: "#fff",
                    activeDrawerFontColor: "#391085",
                    pageBgColor: "#f5f5f5",
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                },
                {
                    topBarBgColor: "#2C2C43", // 头部背景颜色
                    projectNameColor: "#F7F7F7", //名称颜色
                    userNameColor: "#A8A9BB", //用户名颜色
                    titleBgColor: "#2C2C43", //标题背景颜色
                    titleFontColor: "#CACBD6", //标题字体颜色
                    navigationDrawerBgColor: "#222233", //左边导航背景颜色
                    navigationDrawerFontColor: "#F4F4F5", //左边导航字体颜色
                    activeDrawerFontColor: "#A8A9BB", //左边导航点击后的字体颜色
                    pageBgColor: "#2C2C43", //页面背景颜色
                    pageBgColor: "#2C2C43", //页面背景颜色
                    pageFontColor: "#A8A9BB", //页面上的字体颜色
                    elementBgColor: "#222233", //页面上的元素背景
                    tableDark: true,
                },
            ],
        };
    },
    components: {
        TopBar,
    },
    computed: {
        ...mapState(["theme", "navigationMode"]),
    },
    mounted() {},
    methods: {
        /*修改密码*/
        async modify(ruleForm) {
            this.$refs[ruleForm].validate(valid => {
                if (valid) {
                    let postData = {
                        user: this.$store.state.user.name,
                        new_password: this.ruleForm.newPassword,
                        old_password: this.ruleForm.oldPassword,
                    };
                }
            });
        },
        /*选择主题*/
        switchTheme(theme) {
            // let max = this.themes.length;
            // let min = 0;
            // let index = Math.floor(Math.random() * (max - min + 1) + min);
            store.commit("SET_THEME", theme);
            location.reload();
        },
        /*重置主题*/
        reset() {
            localStorage.removeItem("theme");
            location.reload();
        },
        /*退出登录*/
        logOut() {
            store.commit("LOG_OUT");
        },
    },
};
</script>
